import type { ChargeStatus } from '@amai/contracts';
import type { BadgeKind } from '@/components/StatusBadge';

/**
 * Cor de cada situação da cobrança.
 *
 * Mora fora do componente porque duas telas a usam — a parcela do contas a
 * receber e a lista de cobranças — e porque exportar constante do mesmo
 * arquivo que exporta componente quebra o hot reload do Vite.
 */
export const CHARGE_TONE: Record<ChargeStatus, BadgeKind> = {
  PENDENTE: 'info',
  RECEBIDA: 'ok',
  VENCIDA: 'bad',
  ESTORNADA: 'warn',
  CANCELADA: 'mute',
};
